import React from 'react'

const SvgComponent = props => (
  <svg width={54} height={64} {...props}>
    <defs>
      <linearGradient
        x1="-12.039%"
        y1="1.214%"
        x2="155.653%"
        y2="90.79%"
        id="learn__prefix__a"
      >
        <stop stopColor="#FBA4B5" offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M7.563 55.755v6.435c0 .982.79 1.78 1.762 1.78h24.787c.972 0 1.761-.798 1.761-1.78v-6.271h6.921c2.77 0 5.032-2.285 5.032-5.082v-8.898l4.052-.078c1.607-.028 2.622-1.765 1.868-3.196l-4.426-8.427a13.11 13.11 0 0 1-1.5-6.093C47.82 10.742 37.007-.106 23.71 0 10.452.108-.134 11.005 0 24.394c.043 3.858.98 7.502 2.608 10.72a45.595 45.595 0 0 1 4.954 20.641z"
        fill="url(#learn__prefix__a)"
        transform="matrix(-1 0 0 1 54 0)"
      />
      <path
        d="M24.373 27.78a1.569 1.569 0 0 1-1 2.772c-.352 0-.706-.119-.998-.361l-6.026-5.013a1.57 1.57 0 0 1 0-2.412l6.026-5.013a1.561 1.561 0 0 1 2.202.205 1.568 1.568 0 0 1-.204 2.207l-4.576 3.806 4.576 3.808zm9.788-13.315l-5.745 19.886a1.566 1.566 0 0 1-1.938 1.069 1.567 1.567 0 0 1-1.067-1.941l5.745-19.886a1.565 1.565 0 1 1 3.005.872zm9.062 10.713l-6.026 5.013a1.56 1.56 0 0 1-2.202-.204 1.57 1.57 0 0 1 .204-2.208l4.576-3.807-4.576-3.807a1.57 1.57 0 0 1-.204-2.207 1.561 1.561 0 0 1 2.202-.205l6.026 5.013a1.568 1.568 0 0 1 0 2.412z"
        fill="#FFF"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgComponent
